import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LoadingAnimationComponent } from '../../shared/components/loading-animation/loading-animation.component';
import { ErrorComponent } from '../../shared/components/orders/error/error.component';
import { GroupTableComponent } from '../../shared/components/groups/table/group-table.component';
import { ButtonComponent } from '../../shared/components/button/button.component';
import { GroupFilterComponent } from '../../shared/components/groups/filter/group-filter.component';
import { CustomerFrontendManagementService } from '../../core/customer-frontend-management.service';
import { OrderAccessGroupResponse } from '../../shared/models/groups/order-access-group-response.model';
import { QueryParamsService } from '../../core/query-params.service';
import { HttpParams } from '@angular/common/http';
import { Router } from '@angular/router';
import { AddressResponse } from '../../shared/models/order/address-response.model';

@Component({
  selector: 'app-customer-frontend-management',
  standalone: true,
  imports: [CommonModule, LoadingAnimationComponent, ErrorComponent, GroupFilterComponent, GroupTableComponent, ButtonComponent],
  templateUrl: './customer-frontend-management.component.html',
  styleUrl: './customer-frontend-management.component.scss',
})
export class CustomerFrontendManagementComponent implements OnInit {
  isLoading = true;
  error: Error | null = null;
  groups: OrderAccessGroupResponse[] = [];
  totalPages = 0;
  currentPage = 0;
  pageSize = 25;
  customersById = new Map<string, AddressResponse>();

  constructor(
    private cfmService: CustomerFrontendManagementService,
    private queryService: QueryParamsService,
    private router: Router
  ) {}

  ngOnInit(): void {
    const http = this.queryService.getCurrentQueryParams();
    if (!http.get('page') || !http.get('size')) {
      this.queryService.updateQueryParams(
        new HttpParams().set('page', this.currentPage).set('size', this.pageSize)
      );
    }
    this.loadCustomers();
    this.loadGroups(true);
  }

  private loadGroups(showLoading = false): void {
    if (showLoading) this.isLoading = true;
    const http = this.queryService.getCurrentQueryParams();
    this.cfmService.getPaginatedGroups(http).subscribe({
      next: (page) => {
        this.groups = this.withCustomerNames(page.content ?? []);
        this.totalPages = page.totalPages ?? 0;
        this.isLoading = false;
      },
      error: (err: Error) => {
        this.error = err;
        this.isLoading = false;
      },
    });
  }

  filterGroups(params: HttpParams) {
    this.isLoading = true;
    this.cfmService.getPaginatedGroups(params).subscribe({
      next: (page) => {
        this.groups = this.withCustomerNames(page.content ?? []);
        this.totalPages = page.totalPages ?? 0;
        this.queryService.updateQueryParams(params);
        this.isLoading = false;
      },
      error: (err: Error) => {
        this.error = err;
        this.isLoading = false;
      },
    });
  }

  openGroupDialog(group: OrderAccessGroupResponse) {
    this.router.navigate([
      '/order/customer-frontend-management/group',
      String(group.customerId),
      String(group.id),
    ]);
  }

  openNewGroupDialog() {
    this.router.navigate(['/order/customer-frontend-management/group/new']);
  }

  private loadCustomers(): void {
    this.cfmService.getAllCustomers().subscribe({
      next: (customers) => {
        this.customersById = new Map(customers.map((customer) => [customer.id, customer]));
        this.groups = this.withCustomerNames(this.groups);
      },
    });
  }

  private withCustomerNames(groups: OrderAccessGroupResponse[]): OrderAccessGroupResponse[] {
    return groups.map((group) => ({
      ...group,
      customerName: group.customerName || this.customersById.get(String(group.customerId))?.name || String(group.customerId),
    }));
  }
}
